import { addStyles } from 'ethcss'
import item from 'blocks.simple/item/item.jcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { IStyles } from '../../../theme'

const previewWebPageStyles: IStyles = {
    wrapper: {
        ...grid.full,
    },
    loader: {
        zIndex: 0,
        ...item.blackOpacity,
    },
}

addStyles(previewWebPageStyles)
export default previewWebPageStyles
